<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    orderId: {
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.loading = true;
      this.$store.dispatch('bu_trailerTransportOrder/fetchOptions', {
        orderId: this.orderId
      }).then(res => {
        this.options = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      this.$emit('change', this.options.find(item => item.value === val))
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    filterable
    clearable
    style="width: 100%;"
    popper-class="trailer-transport-order-select__popper"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.value"
      :value="item.value"
    >
      <div>
        <div class="flex justify-between">
          <div>
            <span>{{ item.value || '-' }}</span>
          </div>
          <div>
            <span class="label">{{ item.raw.cargoSpecName || '-' }}</span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<style>
.trailer-transport-order-select__popper {
  width: 250px;
}
</style>
<style scoped lang="scss">
.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>
